let isFirstOpen = true;
/**
 * @param {HTMLElement} header
 */
export const initOffcanvasSidebar = (
  header,
  onOpenCallback = (first = false) => {},
  onCloseCallback = () => {}
) => {
  const body = document.querySelector("body");
  const sidebar_button = document.getElementById("burger__button");
  if (!header || !sidebar_button) {
    return;
  }

  const sidebar_close_button = header.querySelector(".sidebar__close");
  const sidebar_overlay = header.querySelector(".header__overlay");

  sidebar_button.addEventListener("click", function () {
    const wasOpen = header.classList.contains("sidebar_opened");
    if (wasOpen) {
      header.classList.remove("sidebar_opened");
      body.style.overflow = "";
    } else {
      header.classList.add("sidebar_opened");
      body.style.overflow = "hidden";
      onOpenSidebar(onOpenCallback);
    }
  });
  sidebar_close_button.addEventListener("click", closeSidebar);
  sidebar_overlay.addEventListener("click", closeSidebar);

  function closeSidebar() {
    header.classList.remove("sidebar_opened");
    body.style.overflow = "";
    onCloseSidebar(onCloseCallback);
  }

  return {
    closeSidebar,
  };
};

function onOpenSidebar(callback = (firstTime = false) => {}) {
  callback(isFirstOpen);
  if (isFirstOpen) {
    isFirstOpen = false;
  }
}

function onCloseSidebar(callback = () => {}) {
  callback();
}
